import { makeVar } from '@apollo/client'

export const graphTooltipEventIdVar = makeVar(null)
